import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import Pagination from '@components/Pagination';
import { useForumPosts, useQuery } from '@hooks';
import { forum_path } from '@routes';

import ForumIndexFilters from '../ForumIndexFilters';
import ForumPostList from '../ForumPostList';
import NewForumPostButton from '../NewForumPostButton';

export default function ForumIndexPage({ order }: { order?: string }) {
  const [searchParams] = useSearchParams();

  const query = useQuery();
  const [page, setPage] = useState(query.get('page') ? Number(query.get('page')) : 1);
  const perPage = 20;

  const { data, forumPosts, pagination, areForumPostsLoading } = useForumPosts({
    page,
    perPage,
    order,
    topic: searchParams.get('topic'),
  });

  const getPath = (page: number) => (page > 1 ? forum_path({ page }) : forum_path());

  return (
    <div>
      <ForumIndexFilters topEntities={data?.top_entities} />
      <div className="container container-padded">
        <main>
          <ForumPostList forumPosts={forumPosts} />
          {forumPosts?.length > 0 ? (
            <Pagination paginationData={pagination} setPage={setPage} getPath={getPath} />
          ) : (
            !areForumPostsLoading && (
              <>
                <p className="serif" style={{ textAlign: 'center' }}>
                  No recent posts.
                </p>
                <NewForumPostButton />
              </>
            )
          )}
        </main>
      </div>
    </div>
  );
}
